export default function PageLinks() {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-bold">Nuttige links</h2>
      <ul className="list-disc pl-5">
        <li>Betrouwbare medische informatie: <a href="https://www.thuisarts.nl" className="text-blue-600 underline" target="_blank">thuisarts.nl</a></li>
        <li>Voorschrift op zak: <a href="https://voorschriftopzak.be/#/welcome" className="text-blue-600 underline" target="_blank">https://voorschriftopzak.be</a></li>
        <li>Resultaten van bloedonderzoek, beeldvorming, verslagen van specialisten... : <a href="https://www.cozo.be/" className="text-blue-600 underline" target="_blank">https://www.cozo.be</a></li>
        <li>Reisinformatie: <a href="https://www.wanda.be/nl/" className="text-blue-600 underline" target="_blank">https://www.wanda.be</a></li>
        <li>Hulp bij rookstop: <a href="https://tabakstop.be/" className="text-blue-600 underline" target="_blank">https://tabakstop.be</a></li>
        <li>Moet ik naar de dokter: <a href="https://moetiknaardedokter.nl/be/" className="text-blue-600 underline" target="_blank">https://moetiknaardedokter.nl</a></li>
        <li>Zelfmoord hulp: <a href="https://www.zelfmoord1813.be/" className="text-blue-600 underline" target="_blank">https://www.zelfmoord1813.be</a></li>
        <li>Luisterlijn voor kinderen en jongeren: <a href="https://awel.be/" className="text-blue-600 underline" target="_blank">https://awel.be</a></li>
      </ul>
    </div>
  );
}
